import React from 'react'
import imganLovato from  '../IMG/SVG/Lovato.svg'
import imganeRomano from  '../IMG/SVG/Romano.svg'
export default function Products() {
  return (
    <>


             <section className="container-fluid "></section>
        <div className="row w-75 mx-auto my-5 ">
          <div className="col-md text-center m-5">
          
            <img src={imganLovato} alt="" />
            <div>
              <h3 className="fs-5 mt-4 px-4 pb-1   ">
                LOVATO AUTO GAS 
              </h3>
              <p className="px-4">
                LOVATO, LANDIRENZO y los CILINDORS EKC, líderes en el mercado internacional, certificadas por las más estrictas normas de calidad, tales como la ISO 9001.
              </p>
            </div>
          </div>

          <div className="col-md text-center  ">
           <img src={imganeRomano} alt="" />
            <div>
              <h3 className="fs-5 mt-4 px-4 pb-1 ">
                Romano Autogas
              </h3>
              <p className="px-4 pb-5 mb-4">
               ROMANO AUTOGAS es una marca líder en la producción y comercialización de componentes
y sistemas de gas natural y GLP para el transporte.
Presente en el mercado nacional e internacional desde hace más de 40 años.
              </p>
            </div>
          </div>

        
       
          </div>
    </>
  )
}
